import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { get } from 'lodash';
import { findResultByEvent, wildcardFilter } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import DatasetSubscriptionsService from '../service';
import { showSubscribers, showSubscribersError } from '../actions';
import actions from '../constants';

export function* subscribers(action) {
  const subs = yield select(selectors.subscribers);
  const {
    filter, role, pageSize, currentPage,
  } = findResultByEvent(subs, action, action.event);
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const { response, error } = yield call(callAdapter, DatasetSubscriptionsService.subscribers(
    action.code,
    action.event,
    wildcardFilter(filter),
    role,
    page,
    size,
  ));

  if (error) {
    yield put(showSubscribersError(action.category, action.code, action.event, error));
  } else {
    yield put(showSubscribers(
      action.category,
      action.code,
      action.event,
      get(response.additional, `${action.category}.name`, ''),
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export default function* subscribersApi() {
  yield takeEvery(
    [actions.FETCH_SUBSCRIBERS, actions.REFRESH_SUBSCRIBERS, actions.UPDATE_SUBSCRIBERS_ROLE_FILTER],
    subscribers,
  );
}
